const rawBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

// API version configuration
export const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';

// Normalized base URL without trailing slash
export const API_BASE_URL = rawBase.replace(/\/$/, '');

// Use versioned API by default (/api/v1)
// Falls back to legacy /api if API_VERSION is set to 'legacy'
export const API_URL =
  API_VERSION === 'legacy' ? `${API_BASE_URL}/api` : `${API_BASE_URL}/api/${API_VERSION}`;

export const withApiBase = path => `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
